<template>
    <section
        id="faq-section" 
        class="py-20 my-20 px-5 md:px-10" 
        :class="context.isDarkMode ? 'bg-semidark-silver' : 'bg-void'" 
    >
        <div class="w-full text-center mt-10">
            <i class="pi pi-question-circle text-silver text-8 xl:text-12"></i>
        </div>
        <p 
            class="text-4xl xl:text-2xl 2xl:text-4xl font-semibold text-center text-2xl mt-5 mb-10" 
            :class="context.isDarkMode ? 'text-silver' : 'text-silver'"
        >
            FAQ - {{ translationHandler.translate('frequent questions', 'capitalize') }}
        </p>
    
        <div class="w-full md:w-3/4 lg:w-3/4 px-0 md:px-10 mx-auto">
            <Accordion :value="openTag">
                <AccordionPanel v-for="tab in tabs" :key="tab.title" :value="tab.value">
                    <AccordionHeader class="my-2">
                        <p class="text-lg md:text-md 2xl:text-lg">
                            {{ translationHandler.translate(tab.title, 'ucfirst') }}
                        </p>
                    </AccordionHeader>
                    <AccordionContent 
                        :class="context.isDarkMode ? 'enforce-bg-semidark-silver' : 'enforce-bg-void'"
                    >
                        <p class="m-0 text-silver text-lg md:text-md 2xl:text-lg">
                            {{ translationHandler.translate(tab.content, 'ucfist') }}
                        </p>
                    </AccordionContent>
                </AccordionPanel>
            </Accordion>
        </div>
    </section>
</template>

<script setup>
import { useContextStore } from '@/stores/context';
import { Accordion, AccordionContent, AccordionHeader, AccordionPanel } from 'primevue';
import { ref } from 'vue';
import translationHandler from '@/composables/handlers/TranslationHandler';

const context = useContextStore();

const openTag = ref(null);
const tabs = ref([
    {
        title: 'what services does cervo digital offer?',
        content: 'we offer website development, virtual stores, custom web systems, api integrations, automation, bots, and web scraping.',
        value: '0'
    },
    {
        title: 'how can i request a quote?',
        content: 'you can contact us through the form below, via whatsapp or at our automated budget.',
        value: '1'
    },
    {
        title: 'are the websites responsive?',
        content: 'yes, all our websites are designed to work perfectly on mobile devices, tablets, and desktops.',
        value: '2'
    },
    {
        title: 'do you integrate with apis?',
        content: 'yes, we perform secure and efficient integrations between different platforms to optimize processes and improve system communication.',
        value: '3'
    },
    {
        title: 'what are the benefits of automation and bots?',
        content: 'automation and bots help reduce repetitive manual tasks, increase productivity, and minimize operational errors.',
        value: '4'
    },
    {
        title: 'what is web scraping and how can it help me?',
        content: 'web scraping is the automated extraction of data from websites. It can be useful for collecting strategic information and improving market analysis.',
        value: '5'
    }
]);

</script>

<style scoped>
    .p-accordionpanel, .p-accordionpanel-active {
        border-bottom: unset!important;
    }
    .p-accordionheader {
        margin-bottom: 1rem!important;
    }
</style>
